import { Badge, Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';

interface NotificationBellButtonProps {
  unreadCount: number;
  isLoading: boolean;
  darkMode: boolean;
  buttonRef: React.Ref<HTMLButtonElement>;
  onClick: () => void;
}

export function NotificationBellButton({
  unreadCount,
  isLoading,
  darkMode,
  buttonRef,
  onClick,
}: NotificationBellButtonProps) {
  const label = `${unreadCount} notification${unreadCount !== 1 ? 's' : ''} non lue${unreadCount !== 1 ? 's' : ''}`;

  return (
    <Tooltip title={label}>
      <IconButton
        color="primary"
        onClick={onClick}
        ref={buttonRef}
        disableRipple
        sx={darkMode ? { color: 'grey.400' } : undefined}
      >
        {isLoading ? (
          <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <NotificationsIcon />
            <Box
              sx={{
                position: 'absolute',
                top: -4, right: -4,
                backgroundColor: 'error.main',
                borderRadius: '50%',
                width: 20, height: 20,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >
              <CircularProgress size={12} thickness={6} sx={{ color: 'common.white' }} />
            </Box>
          </Box>
        ) : (
          <Badge badgeContent={unreadCount} color="error">
            <NotificationsIcon />
          </Badge>
        )}
      </IconButton>
    </Tooltip>
  );
}
